import { useSelector } from 'react-redux';

const useUserProducts = () => {
  const productsState = useSelector((state: MyRACStore.Store) => state.products)
  const breakdownPolicyState = useSelector((state: MyRACStore.Store) => state.policy)
  const featureFlags = useSelector((state: MyRACStore.Store) => state.featureToggle)

  const hasCarInsurancePolicy = productsState?.carInsurance?.policies?.length > 0
  const carInsuranceEnabled = featureFlags?.isLDReady && featureFlags?.enableCarInsuranceWeb;
  const hasBreakdownPolicy = Object.keys(breakdownPolicyState.policyInfo || {}).length > 0
  const hasB2BBreakdownPolicy = hasBreakdownPolicy && Boolean(breakdownPolicyState.policyInfo?.partnerName)

  const isCarInsuranceOnly = hasCarInsurancePolicy && !hasBreakdownPolicy
  const isB2bWithCarInsurance = hasB2BBreakdownPolicy && carInsuranceEnabled
  const isIMAccount = !hasB2BBreakdownPolicy && !isCarInsuranceOnly

  return {
    hasCarInsurancePolicy,
    hasBreakdownPolicy,
    hasB2BBreakdownPolicy,
    isCarInsuranceOnly,
    isB2bWithCarInsurance,
    carInsuranceEnabled,
    isIMAccount,
  }
};

export default useUserProducts;
